import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/LoginClickstreamEvents.ts';

const GOOGLE_LOGIN = defineHotpadsEvent({
  key: 'auth.google_login',
  eventTypeId: '5983',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackGoogleLoginEvent',
  trigger: {
    type: 'interaction',
    location: 'login_screen',
    source: 'button_to_google_login',
    object: 'login_screen|auth_form',
  },
  semanticEvent: 'google_login',
});

const HEADER_LOGIN = defineHotpadsEvent({
  key: 'auth.header_login',
  eventTypeId: '5985',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHeaderLoginEvent',
  trigger: {
    type: 'interaction',
    location: 'hp_header',
    source: 'link_to_sign_in',
    object: 'hp_header|login_component',
  },
  semanticEvent: 'header_sign_in_click',
});

export function emitTrackGoogleLoginEvent() {
  trackHotpadsEventDefinition(GOOGLE_LOGIN);
}

export function emitTrackHeaderLoginEvent() {
  trackHotpadsEventDefinition(HEADER_LOGIN);
}
